import { GENERIC_NOTIFICATION_TYPES } from './PendingCommentItemView';

/**
 * @typedef {Object} NotificationFullItemDTO
 * @property {number} notificationId
 * @property {string} displayName;
 * @property {string} fullName;
 * @property {string} attributes;
 * @property {string} dateTimeString;
 * @property {string} groupName;
 * @property {string} type;
 * @property {boolean} viewed;
 * @property {string} imageUrl;
 * @property {{[key: string]: string }} relativeNameValue
 */

/**
 * @param {NotificationFullItemDTO} notification
 * @returns
 */
export function parseRelativeNameValue(notification) {
    const adhoc_challenge_type = Number(notification.relativeNameValue.adhoc_challenge_type) || 0;
    const format_id = Number(notification.relativeNameValue.format_id) || 0;
    const from_user_name = notification.relativeNameValue.from_user_name;

    return {
        adhoc_challenge_type,
        format_id,
        from_user_name
    };
}

/**
 * key: `pn_adhoc_challenge_ended_format`
 * @param {NotificationFullItemDTO} notification
 * @returns
 */

export function adhocChallengeEnded(notification) {
    if (!notification.relativeNameValue) {
        return '';
    }
    let { format_id } = parseRelativeNameValue(notification);
    format_id = format_id % 4;

    return format_id < 2 ? '' : `_${format_id}`;
}

/**
 * key: `pn_adhoc_challenge_ending_soon_format`
 * @param {NotificationFullItemDTO} notification
 */
export function adhocChallengeEndingSoon(notification) {
    if (!notification.relativeNameValue) {
        return '';
    }

    let { adhoc_challenge_type, format_id } = parseRelativeNameValue(notification);

    if (adhoc_challenge_type === 2) {
        return `_cycling`;
    }
    format_id = format_id % 13;

    return format_id < 2 ? '' : `_${format_id}`;
}

/**
 * key: `pn_adhoc_challenge_first_place_format`
 * @param {NotificationFullItemDTO} notification
 */
export function adhocChallengeFirstPlace(notification) {
    if (!notification.relativeNameValue) {
        return '';
    }
    let { format_id } = parseRelativeNameValue(notification);
    format_id = format_id % 7;

    return format_id < 2 ? '' : `_${format_id}`;
}

/**
 * key: `pn_adhoc_challenge_not_first_place_format`
 * @param {NotificationFullItemDTO} notification
 */
export function adhocChallengeNotFirstPlace(notification) {
    if (!notification.relativeNameValue) {
        return '';
    }
    let { format_id } = parseRelativeNameValue(notification);
    format_id = format_id % 6;

    if (format_id === 2 || format_id === 4 || format_id === 5) {
        return `_${format_id}`;
    }
    return '';
}

/**
 * key: `pn_adhoc_challenge_start_format`
 * @param {NotificationFullItemDTO} notification
 */
export function adhocChallengeStart(notification) {
    if (!notification.relativeNameValue) {
        return '';
    }
    let { adhoc_challenge_type, format_id } = parseRelativeNameValue(notification);
    if (adhoc_challenge_type === 2) {
        return `_cycling`;
    }
    format_id = format_id % 5;

    return format_id < 2 ? '' : `_${format_id}`;
}

/**
 * key: `pn_adhoc_challenge_summary_format`
 * @param {NotificationFullItemDTO} notification
 */
export function adhocChallengeSummary(notification) {
    if (!notification.relativeNameValue) {
        return '';
    }
    let { format_id, from_user_name } = parseRelativeNameValue(notification);
    format_id = format_id % 5;
    format_id = format_id < 2 ? '' : `_${format_id}`;
    if (!!from_user_name) {
        format_id = `_single${format_id}`;
    }
    return format_id;
}

/**
 * key: `pn_adhoc_challenge_rank_down_format`
 * @param {NotificationFullItemDTO} notification
 */
export function challengeRankingDown(notification) {
    if (!notification.relativeNameValue) {
        return '';
    }
    let { adhoc_challenge_type, format_id } = parseRelativeNameValue(notification);
    if (adhoc_challenge_type === 2) {
        return `_cycling`;
    }
    format_id = format_id % 3;

    return format_id < 2 ? '' : `_${format_id}`;
}

/**
 * key: `pn_adhoc_challenge_rank_taken_format`
 * @param {NotificationFullItemDTO} notification
 */
export function challengeRankingTaken(notification) {
    if (!notification.relativeNameValue) {
        return '';
    }
    let { adhoc_challenge_type, format_id } = parseRelativeNameValue(notification);
    if (adhoc_challenge_type === 2) {
        format_id = format_id % 3;
        format_id = format_id < 2 ? '' : `_${format_id}`;
        return `_cycling${format_id}`;
    }

    format_id = format_id % 4;

    return format_id < 2 ? '' : `_${format_id}`;
}

/**
 * key: `pn_adhoc_challenge_rank_up_format`
 * @param {NotificationFullItemDTO} notification
 */
export function challengeRankingUp(notification) {
    if (!notification.relativeNameValue) {
        return '';
    }
    let { format_id } = parseRelativeNameValue(notification);
    format_id = format_id % 13;
    return format_id < 2 ? '' : `_${format_id}`;
}

/**
 *
 * @param {NotificationFullItemDTO} notification
 * parse notification and get nessage format ending
 */
export function parseMessageFormatEnding(notification) {
    if (!notification) {
        return '';
    }
    switch (notification.type) {
        case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_ENDED:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_CHALLENGE_END:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_END:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_ENDED:
            return adhocChallengeEnded(notification);
        case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_ENDING_SOON:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_CHALLENGE_ENDING_SOON:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_ENDING_SOON:
            return adhocChallengeEndingSoon(notification);
        case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_FIRST_PLACE:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_ADHOC_CHALLENGE_FIRST_PLACE:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_FIRST_PLACE:
            return adhocChallengeFirstPlace(notification);
        case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_NOT_FIRST_PLACE:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_CHALLENGE_NOT_FIRST_PLACE:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_NOT_FIRST_PLACE:
            return adhocChallengeNotFirstPlace(notification);
        case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_START:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_ADHOC_CHALLENGE_START:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_START:
            return adhocChallengeStart(notification);
        case GENERIC_NOTIFICATION_TYPES.ADHOC_CHALLENGE_SUMMARY:
        case GENERIC_NOTIFICATION_TYPES.VVFJR_TEAM_CHALLENGE_SUMMARY:
            return adhocChallengeSummary(notification);
        case GENERIC_NOTIFICATION_TYPES.CHALLENGE_RANKING_DOWN:
            return challengeRankingDown(notification);
        case GENERIC_NOTIFICATION_TYPES.CHALLENGE_RANKING_TAKEN:
            return challengeRankingTaken(notification);
        case GENERIC_NOTIFICATION_TYPES.CHALLENGE_RANKING_UP:
            return challengeRankingUp(notification);
        default:
            return '';
    }
}
